
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDragHorizontal as ObiDragHorizontalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-drag-horizontal.js';
 
 
 

 
 export const ObiDragHorizontal = createComponent({
   react: React,
   tagName: 'obi-drag-horizontal',
   elementClass: ObiDragHorizontalElement,
   events: {
     
   }
  });
 
 